document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('collabForm');
  const formStatus = document.getElementById('formStatus');
  const thankYouMessage = document.getElementById('thankYouMessage');

  // If already submitted before (persisted using localStorage)
  if (localStorage.getItem('collabFormSubmitted') === 'true') {
    form.style.display = 'none';
    if (thankYouMessage) {
      thankYouMessage.style.display = 'block';
    }
    return;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    formStatus.innerText = 'Submitting...'; // Show submitting status immediately

    const formData = new FormData(form);
    const urlParams = new URLSearchParams();
    const checkboxGroups = {};

    formData.forEach((val, key) => {
      if (urlParams.has(key)) {
        // Already seen this key, treat as multi-checkbox
        if (!checkboxGroups[key]) {
          checkboxGroups[key] = [urlParams.get(key)];
          urlParams.delete(key);
        }
        checkboxGroups[key].push(val);
      } else {
        urlParams.append(key, val);
      }
    });

    // Append checkbox groups as comma-separated strings
    for (const key in checkboxGroups) {
      urlParams.append(key, checkboxGroups[key].join(', '));
    }

    fetch('https://script.google.com/macros/s/AKfycbx_AkEHxgkB4kbF1WqpQcqcA72EfXITxVbIJtQjTLduMtIh7Jt2owkxTvVoA56JA2gE/exec', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: urlParams
    })
    .then(res => res.json())
    .then(response => {
      form.style.display = 'none';
      if (thankYouMessage) {
        thankYouMessage.style.display = 'block';
      }
      localStorage.setItem('collabFormSubmitted', 'true');
    })
    .catch(err => {
      formStatus.innerText = 'Something went wrong. Please try again.';
      console.error('Form submission error:', err);
    });
  });
});
